import { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Typography, Box, Menu, MenuItem, Tooltip } from '@mui/material';
import { useSelector } from '../../redux/store';
import Iconify from '../iconify';
import { useUpdateOrderItemRedux } from '../../hooks/useUpdateOrderItemRedux';
import { useScopeCheck } from '../scopes';

PreviousOrderSubcategory.propTypes = {
  row: PropTypes.object,
  disabled: PropTypes.bool,
};

export default function PreviousOrderSubcategory({ row, disabled = false }) {
  const { id = '' } = useParams();
  const updateOrderItemRedux = useUpdateOrderItemRedux();
  const hasAccess = useScopeCheck(['Edit-Order'], true);
  const { orderById } = useSelector((state) => state.orders || {});
  const { items = [], orderAgoraCategories = [], agoraSubcategories = [] } = orderById[id] || {};
  const currentCategoryId = row.agoraCategoryId;
  const permittedCategoryIds = new Set(orderAgoraCategories.map((category) => category.id));
  const canEditCategories = hasAccess && items.every((item) => item.agoraCategoryId === 0 || permittedCategoryIds.has(item.agoraCategoryId));
  const tooltipTitle =
    !disabled && !canEditCategories
      ? 'You are not permitted to change categories in this order'
      : !disabled
      ? row.agoraSubcategory || ''
      : '';
  const [anchorEl, setAnchorEl] = useState(null);
  const open = !disabled && canEditCategories && Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Tooltip title={tooltipTitle} placement="top" arrow>
        {canEditCategories && !disabled ? (
          <Typography
            variant="subtitle2"
            sx={{
              border: 1,
              width: '125px',
              borderRadius: '3px',
              position: 'relative',
              display: 'flex', // Use flexbox
              alignItems: 'center',
              '&:hover': {
                cursor: 'pointer',
                backgroundColor: `#C4CDD5`,
              },
              my: '4px',
              py: '2px',
              px: 0.5,
            }}
            onClick={handleClick}
          >
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden', // Hide overflow
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                whiteSpace: 'nowrap', // Prevent wrapping
                pr: 2,
              }}
            >
              {row.agoraSubcategory || '\u00A0'}
            </Box>
            <Box>
              <Iconify icon={'mdi:chevron-down'} />
            </Box>
          </Typography>
        ) : (
          <Typography
            variant="subtitle2"
            sx={{
              border: 1,
              width: '125px',
              borderRadius: '3px',
              position: 'relative',
              display: 'flex', // Use flexbox
              alignItems: 'center',

              my: '4px',
              py: '5px',
              px: 0.5,
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                overflow: 'hidden', // Hide overflow
                textOverflow: 'ellipsis', // Add ellipsis for overflow
                whiteSpace: 'nowrap', // Prevent wrapping
                pr: 2,
              }}
            >
              {row.agoraSubcategory || '\u00A0'}
            </Box>
          </Typography>
        )}
      </Tooltip>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {[...(agoraSubcategories || [])]
          .filter(
            (sub) =>
              sub.mainCategoryId === currentCategoryId
          )
          .sort((a, b) => (a?.name || '').localeCompare(b?.name || '', 'en', { sensitivity: 'base' }))
          .map((subCategory) => (
            <MenuItem
              key={subCategory?.id}
              onClick={() => {
                updateOrderItemRedux(row.id, 'agoraSubcategory', subCategory.name);
                updateOrderItemRedux(row.id, 'agoraSubcategoryId', subCategory.id);
                handleClose();
              }}
            >
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>
                {subCategory?.name}
              </Typography>
            </MenuItem>
          ))}
      </Menu>
    </>
  );
}
